let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "199",
        trackFullPrice: '500',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1664980172512x765105648432578600',
    },
    {
        trackTitle: "Junior Track",
        trackJunior: true,
        trackSubtitle: "For Junior specialists",
        trackPrice: "0",
        trackButton: "Register",
        trackList1: 'Junior Track Access',
        trackLink: 'https://geekle.us/ticketfree/1664979996111x156736163844980740',
    },
    {
        trackTitle: "2 Software Development Events",
        event1: "Vue.js Global Summit'23",
        event2: "AI in Software Development Conf'23",
        event2Link: "https://events.geekle.us/aisoftware/",
        trackPrice: "299",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1682337863554x363156561004593150',
    },
    {
        trackTitle: "Year of Vue.js Events",
        year: "Full Access to the live stream and recordings for 4 events in the Vue.js domain",
        trackPrice: "499",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1683108334357x140811482885521400',
    },
];

export default PackagesItem;
